var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M509.615-140.001q-12.769 0-21.384-8.616-8.616-8.615-8.616-21.384t8.616-21.384Q496.846-200 509.615-200h238.076q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-535.382q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H509.615q-12.769 0-21.384-8.615-8.616-8.615-8.616-21.384t8.616-21.384q8.615-8.616 21.384-8.616h238.076q30.308 0 51.308 21t21 51.308v535.382q0 30.308-21 51.308t-51.308 21H509.615Zm-28.382-310H170.001q-12.769 0-21.384-8.615-8.616-8.615-8.616-21.384t8.616-21.384q8.615-8.615 21.384-8.615h311.232l-76.923-76.923q-8.307-8.308-8.5-20.269-.192-11.961 8.5-21.269 8.692-9.307 21.076-9.615 12.385-.308 21.692 9l123.768 123.768q10.846 10.846 10.846 25.307 0 14.461-10.846 25.307L447.078-330.925q-8.923 8.923-21.192 8.808-12.268-.116-21.576-9.423-8.692-9.308-8.384-21.384.307-12.077 8.999-20.769l76.308-76.308Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.31c972f918105d3ca9151b903bba4444.svg";
export { ForwardRef as ReactComponent };